module.exports = __webpack_public_path__ + "static/media/yoyo.50fa46f4.png";